// CalltoActionSection.jsx
import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { listPromoProducts } from '../../Redux/Actions/ProductActions';
import './newsLetterSection.css';

const cloudinaryOptimize = (url, width = 300) => {
  if (!url || !url.includes('cloudinary.com')) return url;
  return url.replace('/upload/', `/upload/w_${width},f_auto,q_auto/`);
};

const CalltoActionSection = () => {
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.promoProducts);

  useEffect(() => {
    dispatch(listPromoProducts());
  }, [dispatch]);

  const featuredProducts = products?.filter((p) => p.isFeatured) || [];
  const saleProducts = products?.filter((p) => p.onSale && p.salePrice) || [];

  const scroll = (ref, direction) => {
    ref.current?.scrollBy({ left: direction * 260, behavior: 'smooth' });
  };

  const ProductStrip = ({ items, label, accentColor }) => {
    const stripRef = useRef(null);
    if (!items.length) return null;

    return (
      <div className="cta-strip">
        <div className="cta-strip-header">
          <span className="cta-strip-label" style={{ borderColor: accentColor, color: accentColor }}>
            {label}
          </span>
          <div className="cta-strip-arrows">
            <button onClick={() => scroll(stripRef, -1)} className="cta-arrow">&#8592;</button>
            <button onClick={() => scroll(stripRef, 1)} className="cta-arrow">&#8594;</button>
          </div>
        </div>

        <div className="cta-scroll-track" ref={stripRef}>
          {items.map((product) => {
            const isOnSale = product.onSale && product.salePrice;
            const salePrice = Number(product.salePrice);
            const originalPrice = Number(product.price);
            const discountPercent = isOnSale
              ? Math.round((1 - salePrice / originalPrice) * 100)
              : 0;
            const img = cloudinaryOptimize(
              product.images?.[0] || product.image || '/default-image.jpg',
              300
            );

            return (
              <Link to={`/products/${product._id}`} key={product._id} className="cta-card">
                <div className="cta-card-img-wrap">
                  <img src={img} alt={product.name} loading="lazy" className="cta-card-img" />
                  {isOnSale && (
                    <span className="cta-discount-pill">-{discountPercent}%</span>
                  )}
                </div>
                <div className="cta-card-body">
                  <p className="cta-card-name">{product.name}</p>
                  <div className="cta-card-price">
                    {isOnSale ? (
                      <>
                        <span className="cta-sale-price">${salePrice.toFixed(2)}</span>
                        <span className="cta-original-price">${originalPrice.toFixed(2)}</span>
                      </>
                    ) : (
                      <span className="cta-regular-price">${originalPrice.toFixed(2)}</span>
                    )}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="subscribe-section bg-with-black">
      <div className="container">
        <div className="subscribe-head">
          <h2>Don't Miss Out</h2>
          <p>Hand-picked deals and featured collectibles just for you</p>
        </div>

        <ProductStrip items={saleProducts} label="🔥 On Sale" accentColor="#41f583" />
        <ProductStrip items={featuredProducts} label="⭐ Featured" accentColor="#f4c430" />
      </div>
    </div>
  );
};

export default CalltoActionSection;